"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

exports.__esModule = true;

var emotion_theming_1 = require("emotion-theming");

var React = require("react");

var react_inspector_1 = require("react-inspector");

var ObjectPreview_1 = require("react-inspector/lib/object-inspector/ObjectPreview");

var elements_1 = require("./elements");

var CustomInspector =
/** @class */
function (_super) {
  __extends(CustomInspector, _super);

  function CustomInspector() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CustomInspector.prototype.render = function () {
    var _a = this.props,
        data = _a.data,
        theme = _a.theme;
    var styles = theme.styles,
        method = theme.method;
    var dom = data instanceof HTMLElement;
    var table = method === 'table';
    return React.createElement(elements_1.Root, {
      "data-type": table ? 'table' : dom ? 'html' : 'object'
    }, table ? React.createElement(elements_1.Table, null, React.createElement(react_inspector_1.Inspector, __assign({}, this.props, {
      theme: styles,
      table: true
    })), React.createElement(react_inspector_1.Inspector, __assign({}, this.props, {
      theme: styles
    }))) : dom ? React.createElement(elements_1.HTML, null, React.createElement(react_inspector_1.DOMInspector, __assign({}, this.props, {
      theme: styles
    }))) : React.createElement(react_inspector_1.Inspector, __assign({}, this.props, {
      theme: styles,
      nodeRenderer: this.nodeRenderer.bind(this)
    })));
  };

  CustomInspector.prototype.getCustomNode = function (data) {
    var styles = this.props.theme.styles;
    var constructor = data && data.constructor ? data.constructor.name : null;
    if (constructor === 'Function') return React.createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, React.createElement(ObjectPreview_1["default"], {
      data: data
    }), " {", React.createElement("span", {
      style: {
        color: 'rgb(181, 181, 181)'
      }
    }, data.body), "}");
    if (constructor === 'Promise') return React.createElement("span", {
      style: {
        fontStyle: 'italic'
      }
    }, "Promise ", "{", React.createElement("span", {
      style: {
        opacity: 0.6
      }
    }, "<pending>"), "}");
    if (data instanceof HTMLElement) return React.createElement(elements_1.HTML, null, React.createElement(react_inspector_1.DOMInspector, {
      data: data,
      theme: styles
    }));
    return null;
  };

  CustomInspector.prototype.nodeRenderer = function (props) {
    var depth = props.depth,
        name = props.name,
        data = props.data,
        isNonenumerable = props.isNonenumerable; // Root

    if (depth === 0) {
      var customNode_1 = this.getCustomNode(data);
      return customNode_1 || React.createElement(react_inspector_1.ObjectRootLabel, {
        name: name,
        data: data
      });
    }

    if (name === 'constructor') return React.createElement(elements_1.Constructor, null, React.createElement(react_inspector_1.ObjectLabel, {
      name: "<constructor>",
      data: data.name,
      isNonenumerable: isNonenumerable
    }));
    var customNode = this.getCustomNode(data);
    return customNode ? React.createElement(elements_1.Root, null, React.createElement(react_inspector_1.ObjectName, {
      name: name
    }), React.createElement("span", null, ": "), customNode) : React.createElement(react_inspector_1.ObjectLabel, {
      name: name,
      data: data,
      isNonenumerable: isNonenumerable
    });
  };

  return CustomInspector;
}(React.PureComponent);

exports["default"] = emotion_theming_1.withTheme(CustomInspector);